import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import VaccinationChart from "./VaccinationChart";
import DynamicHelmet from "./DynamicHelmet";
import { loadVaccinationData, SchoolData } from "../data/dataTable";

const SchoolDetail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const schoolCode = searchParams.get("schoolCode") || "";
  const [schoolName, setSchoolName] = useState<string>("");

  useEffect(() => {
    const fetchSchoolData = async () => {
      try {
        const data = await loadVaccinationData();
        const school = data.find(
          (s: SchoolData) => s.schoolCode === schoolCode
        );
        if (school) {
          setSchoolName(school.schoolName);
        }
      } catch (error) {
        console.error("Error fetching school data:", error);
      }
    };

    if (schoolCode) {
      fetchSchoolData();
    }
  }, [schoolCode]);

  const handleGoBack = () => {
    navigate("/");
  };

  return (
    <div className="school-detail">
      <DynamicHelmet
        title={`${schoolName}`}
        description={`View vaccination data for ${schoolName} in California.`}
        url={`/school?schoolCode=${encodeURIComponent(schoolCode)}`}
      />
      <VaccinationChart schoolCode={schoolCode} onGoBack={handleGoBack} />
    </div>
  );
};

export default SchoolDetail;
